import React from 'react';
import { PlayIcon } from 'lucide-react';
import { Container, Section } from '../ui/Section';
import { Reveal } from '../motion/Reveal';
import { videoPosterPhoto } from '../../data/photos';
type WelcomeVideoProps = {
  /** Once a real montage file exists, pass its hosted MP4/WebM URL here. */
  videoSrc?: string;
};
export function WelcomeVideo({
  videoSrc
}: WelcomeVideoProps) {
  return <Section className="bg-[#fffdf6] py-16 sm:py-20" labelledBy="video-heading" data-id="element-253" data-mp="334srdw3rbves">
      <Container className="max-w-4xl" data-id="element-254" data-mp="383m2xizhhccb">
        <Reveal data-id="element-255" data-mp="384ndzngi1yu1">
          <h2 id="video-heading" className="font-serif text-3xl font-semibold leading-tight text-brand-navy sm:text-4xl" data-id="element-256" data-mp="3856z1d1g53ca">
            See what BCM is like
          </h2>
          <p className="mt-4 font-sans text-[17px] leading-relaxed text-ink" data-id="element-257" data-mp="2y5y4oj2o5mpe">
            A new welcome video featuring BCM students, worship, outreach, and community is being
            created for the fall semester.
          </p>
        </Reveal>

        <Reveal delay={0.1} className="mt-8 overflow-hidden rounded-[20px] border-2 border-brand-navy bg-brand-blue" data-id="element-258" data-mp="239azzvytdwl1">
          {videoSrc ? <video controls preload="metadata" className="aspect-video w-full bg-black" aria-label="UCF BCM welcome video" data-id="element-259" data-mp="1ya6pn205lst4">
              <source src={videoSrc} data-id="element-260" data-mp="2811fegclzajb" />
              Your browser does not support embedded video.
            </video> : <div className="relative" data-id="element-261" data-mp="1kcrvxl2vayvc">
              {videoPosterPhoto.src ? <img src={videoPosterPhoto.src} alt={videoPosterPhoto.alt} className="aspect-video w-full object-cover" data-id="element-262" data-mp="1fdoueam3jas4" /> : <div className="flex aspect-video w-full items-center justify-center px-6 text-center" data-id="element-263" data-mp="1pceca3dzsv8d">
                  <p className="font-meta text-[15px] font-semibold text-brand-navy" data-id="element-264" data-mp="35q4e13hn37eu">
                    Add Image here
                  </p>
                </div>}
              <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 bg-brand-navy/55" data-id="element-265" data-mp="37s52jr3ejuc3">
                <span aria-hidden="true" className="flex h-16 w-16 items-center justify-center rounded-full border-2 border-white/70 bg-white/25" data-id="element-266" data-mp="3ctb1i6nnodu2">
                  <PlayIcon className="h-7 w-7 text-white" data-id="element-267" data-mp="3mnbc2o1piba6" />
                </span>
                <p className="rounded-full bg-brand-tan px-4 py-2 font-meta text-[13px] font-semibold text-brand-navy" data-id="element-268" data-mp="2ozst6kebzssg">
                  New welcome video coming soon.
                </p>
              </div>
            </div>}
        </Reveal>
      </Container>
    </Section>;
}